export default __webpack_public_path__ + "static/media/glrc.content.micro_courses.2baa6eaf.jpg";